import React, { useEffect } from 'react';
import './QuotationOptions.css';

const QuotationOptions = ({
  showHsnColumn,
  setShowHsnColumn,
  taxType,
  setTaxType,
  gstRate,
  setGstRate,
  igstRate,
  setIgstRate,
  hasdiscount,
  setHasdiscount,
  discount,
  setDiscount,
  isMobile
}) => {
  // Ensure a default tax type is set if none is provided
  useEffect(() => {
    if (!taxType || taxType === '') {
      setTaxType('SGST_CGST'); // Set SGST_CGST as default
    }
  }, [taxType, setTaxType]);

  // Force HSN OFF whenever tax type becomes NONE
  useEffect(() => {
    if (taxType === 'NONE' && showHsnColumn) {
      setShowHsnColumn(false);
    }
  }, [taxType, showHsnColumn, setShowHsnColumn]);

  return (
    <div className="QuotationForm__options-container">
      {/* First Row - Tax Configuration and GST Rate */}
      <div className="QuotationForm__options-row QuotationForm__options-row--main">
        {/* Tax Configuration Section */}
        <div className="QuotationForm__tax-section">
          <div className="QuotationForm__tax-content">
            <label className="QuotationForm__label QuotationForm__label--inline">Tax Configuration</label>
            <div className="QuotationForm__radio-group-horizontal">
              <div className="QuotationForm__radio-item">
                <input
                  type="radio"
                  id="sgst_cgst"
                  name="taxType"
                  value="SGST_CGST"
                  checked={taxType === 'SGST_CGST'}
                  onChange={(e) => setTaxType(e.target.value)}
                  className="QuotationForm__radio"
                />
                <label htmlFor="sgst_cgst" className="QuotationForm__radio-label">SGST + CGST</label>
              </div>
              
              <div className="QuotationForm__radio-item">
                <input
                  type="radio"
                  id="igst"
                  name="taxType"
                  value="IGST"
                  checked={taxType === 'IGST'}
                  onChange={(e) => setTaxType(e.target.value)}
                  className="QuotationForm__radio"
                />
                <label htmlFor="igst" className="QuotationForm__radio-label">IGST</label>
              </div>
              
              <div className="QuotationForm__radio-item">
                <input
                  type="radio"
                  id="no_tax"
                  name="taxType"
                  value="NONE"
                  checked={taxType === 'NONE'}
                  onChange={(e) => setTaxType(e.target.value)}
                  className="QuotationForm__radio"
                />
                <label htmlFor="no_tax" className="QuotationForm__radio-label">No Tax</label>
              </div>
            </div>
          </div>
        </div>

        {/* GST Rate Section */}
        <div className="QuotationForm__gst-section">
          {taxType === 'SGST_CGST' && (
            <div className="QuotationForm__field-group">
              <label className="QuotationForm__label">GST Rate (%)</label>
              <input
                type="text"
                inputMode="decimal"
                className="QuotationForm__input QuotationForm__input--no-spinner"
                value={gstRate}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === '' || (/^\d*\.?\d*$/.test(value) && parseFloat(value) >= 0 && parseFloat(value) <= 50)) {
                    setGstRate(value === '' ? 0 : parseFloat(value) || 0);
                  }
                }}
              />
            </div>
          )}

          {taxType === 'IGST' && (
            <div className="QuotationForm__field-group">
              <label className="QuotationForm__label">IGST Rate (%)</label>
              <input
                type="text"
                inputMode="decimal"
                className="QuotationForm__input QuotationForm__input--no-spinner"
                value={igstRate}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === '' || (/^\d*\.?\d*$/.test(value) && parseFloat(value) >= 0 && parseFloat(value) <= 100)) {
                    setIgstRate(value === '' ? 0 : parseFloat(value) || 0);
                  }
                }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Second Row - Discount Section */}
      <div className="QuotationForm__options-row QuotationForm__options-row--secondary">
        <div className="QuotationForm__discount-section">
          <div className="QuotationForm__discount-wrapper">
            <div className="QuotationForm__toggle-group">
              <label className="QuotationForm__toggle-label">
                Include Discount
              </label>
              <div 
                className={`QuotationForm__toggle ${hasdiscount ? 'QuotationForm__toggle--active' : ''}`}
                onClick={() => setHasdiscount(!hasdiscount)}
              >
                <div className="QuotationForm__toggle-slider"></div>
              </div>
            </div>
            
            {hasdiscount && (
              <div className="QuotationForm__discount-input-wrapper">
                <div className="QuotationForm__field-group">
                  <label className="QuotationForm__label">Discount (%)</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="QuotationForm__input QuotationForm__input--small QuotationForm__input--no-spinner"
                    value={discount}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (/^\d*\.?\d*$/.test(value) && parseFloat(value) >= 0 && parseFloat(value) <= 100)) {
                        setDiscount(value === '' ? 0 : parseFloat(value) || 0);
                      }
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationOptions;